// extracted by mini-css-extract-plugin
export default {"container":"SegmentedProgressBars_container__alxJ7"};